import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { c as classNamePropTypes } from './classNames-cc2dcbf1.js';
import { m as marginPropTypes } from './spacing-7e57ffb0.js';
import { S as SvgIcon } from './SvgIcon-1308e965.js';

function IconWind(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.866 3.53a.668.668 0 0 1-.946-.94A2 2 0 1 1 7.332 6h-6a.667.667 0 1 1 0-1.334h6.003a.666.666 0 1 0-.471-1.136zm1.055 9.88a.667.667 0 1 1 .946-.94.668.668 0 0 0 1.117-.643.667.667 0 0 0-.649-.493h-8a.667.667 0 1 1 0-1.334h7.997a1.999 1.999 0 0 1 1.007 3.733 1.998 1.998 0 0 1-2.417-.323zm4.37-7.785a.668.668 0 0 1-.942-.944A2.333 2.333 0 1 1 13 8.667H1.333a.667.667 0 1 1 0-1.334h11.665a1 1 0 1 0-.708-1.708z"
  }));
}
IconWind.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg', 'none']),
  /** CSS class to use, if any */
  className: classNamePropTypes,
  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white']),
  /** margin for icon, if any */
  margin: marginPropTypes
};
IconWind.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};

export { IconWind as default };
